import $ from 'jquery';

// Enhance WooCommerce's checkout rather than replacing its payment/validation lifecycle.
$(() => {
    const form = document.querySelector('form.Checkout');
    if (!form || !document.body.classList.contains('ravessa-checkout-page')) return;
    const mobile = window.matchMedia('(max-width: 900px)');
    let productsOpen = !mobile.matches;
    let consentChecked = !!form.querySelector('#custom_checkbox')?.checked;
    let focusBeforeUpdate = null;
    const products = () => form.querySelector('.Checkout__products');
    if (products()) products().open = productsOpen;
    form.addEventListener('toggle', (event) => {
        if (event.target.matches('.Checkout__products')) productsOpen = event.target.open;
    }, true);
    mobile.addEventListener('change', () => {
        productsOpen = !mobile.matches;
        if (products()) products().open = productsOpen;
    });
    form.addEventListener('change', (event) => {
        if (event.target.id === 'custom_checkbox') consentChecked = event.target.checked;
    });

    $(document.body).on('update_checkout.ravessa', () => {
        form.classList.add('is-updating');
        form.querySelector('#place_order')?.setAttribute('aria-disabled', 'true');
        form.querySelector('.Checkout__summary')?.setAttribute('aria-busy', 'true');
        const active = document.activeElement;
        focusBeforeUpdate = active?.closest('.Checkout__delivery, #payment') ? active.id : null;
    }).on('updated_checkout.ravessa', () => {
        form.classList.remove('is-updating', 'is-stale');
        form.querySelector('#place_order')?.removeAttribute('aria-disabled');
        form.querySelector('.Checkout__connectionError').hidden = true;
        form.querySelector('.Checkout__summary')?.setAttribute('aria-busy', 'false');
        if (products()) products().open = productsOpen;
        const consent = form.querySelector('#custom_checkbox');
        if (consent) consent.checked = consentChecked;
        if (focusBeforeUpdate && document.activeElement === document.body) {
            document.getElementById(focusBeforeUpdate)?.focus({ preventScroll: true });
        }
        focusBeforeUpdate = null;
        const total = form.querySelector('.order-total td')?.textContent.trim();
        const live = form.querySelector('.Checkout__live');
        if (live && total) live.textContent = 'Podsumowanie zaktualizowane. Do zapłaty: ' + total;
    });
    $(document).on('ajaxError.ravessaCheckout', (_event, xhr, settings) => {
        if (!settings.url?.includes('wc-ajax=update_order_review') || xhr.statusText === 'abort') return;
        form.classList.remove('is-updating');
        form.classList.add('is-stale');
        form.querySelector('.Checkout__summary')?.setAttribute('aria-busy', 'false');
        $(form).find('.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table').unblock();
        form.querySelector('.Checkout__connectionError').hidden = false;
    });
    $(form).on('checkout_place_order.ravessa', () => {
        if (form.classList.contains('is-cross-selling')) {
            form.querySelector('.Checkout__live').textContent = 'Trwa aktualizacja dodatków. Poczekaj na przeliczenie zamówienia.';
            return false;
        }
        if (form.querySelector('.CheckoutCrossSell.is-uncertain')) {
            const error = form.querySelector('.CheckoutCrossSell [data-accessory-error]:not([hidden])');
            error?.setAttribute('tabindex', '-1');
            error?.focus({ preventScroll: false });
            return false;
        }
        if (form.classList.contains('is-stale') || form.classList.contains('is-updating')) {
            const notice = form.querySelector('.Checkout__connectionError');
            if (!notice.hidden) notice.querySelector('button').focus();
            // WooCommerce clears its pending update timer before this hook. Resume
            // recalculation when submission was blocked while totals were updating.
            if (form.classList.contains('is-updating')) $(document.body).trigger('update_checkout');
            return false;
        }
        // One native submission hook covers the button and Enter. WooCommerce ignores
        // repeat clicks while processing; a retry after validation is a new intent.
        const payment = form.querySelector('#payment');
        const total = Number(payment?.dataset.orderTotal ?? NaN);
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'wc_payment_intent',
                payment_method: form.querySelector('[name="payment_method"]:checked')?.value || null,
                value: Number.isFinite(total) ? total : null,
                currency: payment?.dataset.currency || null,
            });
        } catch (_error) {
            // A tracking integration must never block placing the order.
        }
        return true;
    });
    form.querySelector('[data-checkout-retry]').addEventListener('click', () => {
        $(document.body).trigger('update_checkout');
    });

    // Associate human-readable feedback with the same controls WooCommerce validates.
    const showError = (input, message) => {
        const row = input.closest('.form-row');
        if (!row || !input.id) return;
        const id = input.id + '-checkout-error';
        const themeError = document.getElementById(id);
        const nativeErrors = [...row.querySelectorAll('.checkout-inline-error-message')]
            .filter((error) => error.id === input.id + '_description');
        let error = nativeErrors[0] || themeError;
        const described = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
        described.delete(id);
        [themeError, ...nativeErrors].filter(Boolean).forEach((existing) => {
            described.delete(existing.id);
            if (!message || existing !== error) existing.remove();
        });
        if (!message) error = null;
        if (!error && message) {
            error = document.createElement('span');
            error.id = id;
            error.className = 'Checkout__fieldError';
            row.appendChild(error);
        }
        if (error) {
            error.textContent = message;
            described.add(error.id);
        }
        if (described.size) input.setAttribute('aria-describedby', [...described].join(' '));
        else input.removeAttribute('aria-describedby');
        if (message) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
        row.classList.toggle('woocommerce-invalid', !!message);
    };
    form.addEventListener('focusout', (event) => {
        const input = event.target;
        const row = input.closest('.form-row');
        if (!row || !input.matches('input.input-text, select, textarea') || !row.getClientRects().length) return;
        let message = '';
        if (row.classList.contains('validate-required') && !input.value.trim()) message = 'Uzupełnij to pole.';
        else if (input.type === 'email' && input.value && input.validity.typeMismatch) message = 'Sprawdź adres e-mail, np. anna@example.com.';
        showError(input, message);
    });
    form.addEventListener('input', (event) => {
        if (event.target.hasAttribute('aria-invalid')) showError(event.target, '');
    });
    form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"]:checked')) showError(event.target, '');
    });
    $(document.body).on('checkout_error.ravessa', () => {
        form.classList.remove('is-updating');
        // Newer WooCommerce appends native inline errors after firing this event.
        // Reuse them once that render finishes; older versions use the theme fallback.
        queueMicrotask(() => {
            const errors = [...form.querySelectorAll('.woocommerce-error [data-id]')];
            errors.forEach((notice) => {
                const input = document.getElementById(notice.dataset.id);
                if (input) showError(input, notice.textContent.trim());
            });
            const input = errors.map((notice) => document.getElementById(notice.dataset.id)).find((el) => el && el.getClientRects().length);
            const notice = form.querySelector('.woocommerce-NoticeGroup-checkout, .woocommerce-error');
            if (notice) {
                notice.tabIndex = -1;
                notice.focus({ preventScroll: true });
            }
            // WooCommerce scrolls to its error summary; focus makes it keyboard/screen-reader accessible.
            if (!notice && input) input.focus();
        });
    });

    const couponForm = document.getElementById('ravessa-checkout-coupon');
    if (couponForm && window.wc_checkout_params) {
        couponForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const input = document.getElementById('checkout-coupon-code');
            const button = form.querySelector('.Checkout__couponControls button');
            const notice = form.querySelector('.Checkout__couponNotice');
            if (button.disabled) return;
            const code = input.value.trim();
            if (!code) {
                notice.classList.add('Checkout__couponNotice--error');
                notice.textContent = 'Wpisz kod rabatowy.';
                input.focus();
                return;
            }
            button.disabled = true;
            notice.classList.remove('Checkout__couponNotice--error');
            notice.textContent = 'Sprawdzamy kod…';
            $.ajax({
                type: 'POST',
                url: window.wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon'),
                data: { security: window.wc_checkout_params.apply_coupon_nonce, coupon_code: code },
                dataType: 'html',
                timeout: 20000,
            }).done((html) => {
                const response = new DOMParser().parseFromString(html, 'text/html');
                const success = response.querySelector('.woocommerce-message');
                const error = response.querySelector('.woocommerce-error');
                const failed = !success || !!error;
                notice.classList.toggle('Checkout__couponNotice--error', failed);
                notice.textContent = (error || success)?.textContent.trim() || 'Nie udało się sprawdzić kodu. Spróbuj ponownie.';
                if (!failed) {
                    input.value = '';
                    $(document.body).trigger('applied_coupon_in_checkout', [code]);
                    $(document.body).trigger('update_checkout', { update_shipping_method: false });
                    $(document.body).trigger('wc_fragment_refresh');
                }
            }).fail(() => {
                notice.classList.add('Checkout__couponNotice--error');
                notice.textContent = 'Nie udało się sprawdzić kodu. Spróbuj ponownie.';
            }).always(() => { button.disabled = false; });
        });
    }
});
